<template>
  <iRow class="side-nav">
    <iMenu
      orientation="vertical"
      :active-item="activeItem"
      :items="SIDE_NAV_EXPLORE"
      :style-overrides="SIDE_NAV_STYLE_OVERRIDES"
    />
  </iRow>
</template>

<script>
import { SIDE_NAV_EXPLORE, SIDE_NAV_STYLE_OVERRIDES } from "@/constants/nav-constants";

export default {
  name: "SettingsSideNav",
  props: {
    activeItem: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      SIDE_NAV_EXPLORE,
      SIDE_NAV_STYLE_OVERRIDES,
    };
  },
};
</script>
